import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Navigate, useLocation } from 'react-router-dom';
import { resetLogin, loginAccount } from '../actions/login';
import Login from '../components/Login';
import { closeLoginModal, openForgotPasswordModal, openSignUpModal } from '../actions/auth';
import { getLogin } from '../selectors/login';

const LoginContainer = (props) => {
  const location = useLocation();
  const { hasToken, closeLoginModal, resetLogin } = props;

  useEffect(() => {
    closeLoginModal();
    resetLogin();
  }, []); 

  if (hasToken) {
    return <Navigate to="/dashboard" replace />;
  }

  const isReferred = !!(location?.state?.from?.state?.isReferred);

  return (
    <div>
      <Login
        {...props.loginProps}
        isReferred={isReferred}
        onOpenForgotPassword={props.openForgotPasswordModal}
        handleOpenSignUpModal={props.openSignUpModal}
        closeLoginModal={props.closeLoginModal}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    hasToken: state.auth.hasToken,
    loginProps: getLogin(state)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeLoginModal, loginAccount, openForgotPasswordModal, openSignUpModal, resetLogin }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);